import { loadIntersectionObserver } from '../util/load-dependencies';

function runCounter(el, numberFormatter) {
	const currentNum = parseInt(el.getAttribute('data-number-current') || '1', 10);
	const endNum = parseInt(el.getAttribute('data-number-end') || '1', 10);
	const interval = parseInt(el.getAttribute('data-interval') || '1', 10);
	const delay = parseInt(el.getAttribute('data-delay') || '50', 10);

	if (currentNum >= endNum) {
		return;
	}

	setTimeout(() => {
		el.setAttribute('aria-label', endNum);
		requestAnimationFrame(() => {
			let newNumber = currentNum + interval;

			if (newNumber > endNum) {
				newNumber = endNum;
			}

			el.textContent = numberFormatter.format(newNumber);
			el.setAttribute('data-number-current', newNumber);

			runCounter(el, numberFormatter);
		});
	}, delay);
}

class BlockStats {
	constructor(blockEl) {
		this.blockEl = blockEl;
		this.counterEls = Array.from(
			this.blockEl.querySelectorAll('.block-stats__stat-counter-value')
		);
		this.numberFormatter = new Intl.NumberFormat('en-US');

		this.init();
	}

	async init() {
		const ioAvailable = await loadIntersectionObserver();

		if (!ioAvailable) {
			return;
		}

		let vpThreshold = 0.5;

		if (window.innerWidth < 1025) {
			// medium threshold
			vpThreshold = 0.25;
		} else if (window.innerWidth < 641) {
			// small threshold
			vpThreshold = 0.15;
		}

		const observer = new IntersectionObserver(
			(observerEntries) => {
				const targetEntry = observerEntries[0] || null;

				if (!targetEntry) {
					observer.disconnect();
					return;
				}

				if (targetEntry.intersectionRatio > 0) {
					observer.disconnect();
					this.runCounters();
				}
			},
			{
				threshold: vpThreshold
			}
		);

		observer.observe(this.blockEl);
	}

	runCounters() {
		this.counterEls.forEach((counterEl) => runCounter(counterEl, this.numberFormatter));
	}
}

export default BlockStats;
